var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"33","viewBox":"0 0 17 33","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16 1L1 16.5L16 32","stroke":"#3A913F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }